export default __webpack_public_path__ + "locales/it/SharingPanel.json?hash=a4e7e3c5bdf65ae9cfdeef4d0a8ace13";